import {
    ua,
    qs,
    getDeepVal,
    fenToYuan,
    getJsonParse,
    getCookie,
    setCookie,
    miniNav,
} from '@kkmh/utils'
import {
    forward,
} from '@kk/h5-sdk'
/*
* @param : millisecond 毫秒数
* 返回 : {dd:01, hh:24, mm:02, ms:99}
*/
export const getTimer = (millisecond) => {
    // 计算时分秒数
    let dd = parseInt(millisecond / 1000 / 60 / 60 / 24);
    let hh = parseInt(millisecond / 1000 / 60 / 60 % 24);
    let mm = parseInt(millisecond / 1000 / 60 % 60);
    let ss = parseInt(millisecond / 1000 % 60);
    let ms = Math.floor(millisecond % 1000 / 10);

    return {
        dd : dd > 9 ? ''+dd : '0' + dd,
        hh : hh > 9 ? ''+hh : '0' + hh,
        mm : mm > 9 ? ''+mm : '0' + mm,
        ss : ss > 9 ? ''+ss : '0' + ss,
        ms : ms > 9 ? ''+ms : '0' + ms,
    }
}
export const jumpToVipPage = (pageName) => {
    let url = '';
    switch (pageName) {
        case '更多特权':
            url = "https://www.kuaikanmanhua.com/anim/vip/help.html?type=1";
            break;
        case '每日礼包':
            url = "https://www.kuaikanmanhua.com/anim/vip/help.html?type=1";
            break;
        case '作品限免':
            url = "https://www.kuaikanmanhua.com/anim/vip/help.html?type=3";
            break;
        case '会员85折':
            url = "https://www.kuaikanmanhua.com/anim/vip/help.html?type=4";
            break;
        case '尊贵身份':
            url = "https://www.kuaikanmanhua.com/anim/vip/help.html?type=5";
            break;
        case '签到特权':
            url = "https://www.kuaikanmanhua.com/anim/vip/help.html?type=6";
            break;
        case '常见问题':
            url = "https://www.kuaikanmanhua.com/anim/vip/faq.html";
            break;
        case '服务协议':
            url = "https://www.kuaikanmanhua.com/anim/vipAgreement.html";
            break;
        case '自动续费':
            url = "https://www.kuaikanmanhua.com/anim/autoRenew.html";
            break;
        case '交易明细':
            url = "https://www.kuaikanmanhua.com/webapp/vip/member_bill.html";
            if (qs['env'] == 's') {
                url = url + '?env=s';
            }
            break;
        case '苹果支付教程':
            if (ua['iphone']) {
                url = "https://www.kuaikanmanhua.com/webapp/ios/vip-pay-help.html";
            }
            break;
    }
    if (!url) return;
    if (ua['kkmh']) {
        forward({
            todata  : {},
            totype  : 'h5',
            topage  : url,
            callback : (res) => {
                let {data={}} = res;
                if (data.status == 1) { //跳转成功
                }
                if (data.status == 2) { //h5回来不执行
                }
            }
        });
    } else if(ua['miniprogram']) {
        miniNav(`/pages/webview/webview?url=${encodeURIComponent(url)}`);
    } else {
        location.href = url;
    }
}
//
export const setSelectCouponId = (current_goodid, current_couponid) => {
    // setCookie('V_COUPON_ID', '{"good_id_45":456,"good_id_2":123,"good_id_3":"noneuse"}');
    var obj = getJsonParse(getCookie('V_COUPON_ID'));
    obj['good_id_' + current_goodid] = current_couponid;
    setCookie('V_COUPON_ID', JSON.stringify(obj));
}
export const getSelectCouponId = (current_goodid) => {
    // setCookie('V_COUPON_ID', '{"good_id_45":456,"good_id_2":123,"good_id_3":"noneuse"}');
    var obj = getJsonParse(getCookie('V_COUPON_ID'));
    return obj['good_id_'+current_goodid] || '';
}
export const getSelectCouponPrice = (good) => {
    var opt = formatCoupon(good);
    return opt.couponprice;
}

export const formatCoupon = (good) => {
    var ary         = getDeepVal(good,'coupon.usable_list',[]);
    var sel_couponid= getSelectCouponId(good.id);

    var coupontitle = '暂无优惠券，换个套餐试试';
    var couponprice = 0;
    var couponid    = 0;
    
    //1.默认第一个
    if (ary.length > 0) {
        ary[0].coupon_time_tip = ary[0].coupon_time_tip || '';
        coupontitle = '<div class="price"><span>'+ary[0].coupon_time_tip+'</span><span>-￥'+fenToYuan(ary[0].amount,2)+'</span></div>';
        couponprice = ary[0].amount;
        couponid    = ary[0].id;
    }
    //2.选中的
    if(ary.length > 0 && sel_couponid) {
        ary.forEach((item,index) => {
            if (item.id == sel_couponid){
                item.coupon_time_tip = item.coupon_time_tip || '';
                coupontitle = '<div class="price"><span>'+item.coupon_time_tip+'</span><span>-￥'+fenToYuan(item.amount,2)+'</span></div>';
                couponprice = item.amount;
                couponid    = item.id;
            }
        })
    }
    //3.不使用优惠券
    if (sel_couponid == 'noneuse') {
        coupontitle = '暂不使用优惠券';
        couponprice = 0;
        couponid    = 0;
    }

    let deal_price = getDeepVal(good,'price.real_price',0) - couponprice;
    return {
        coupontitle : coupontitle,
        couponprice : couponprice,
        couponid    : couponid,
        coupon_price : couponprice,
        deal_price,
    }
}


// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/components/viphalfscreen/js/comp.js